module.exports = __webpack_public_path__ + "img/small-10.c6144b4a.jpg";